"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorLegendItems = void 0;
var tslib_1 = require("tslib");
var isLegendItemI = function (legendItems) {
    return typeof legendItems[0].value === 'number';
};
var getColorLegendItems = function (legendItems) {
    var items = [];
    if (isLegendItemI(legendItems)) {
        if (legendItems.length === 1)
            return [];
        var cache = new Map();
        for (var index = 0; index < legendItems.length; index++) {
            var _a = legendItems[index], color = _a.color, value = _a.value;
            if (cache.has(color)) {
                var data = cache.get(color);
                if (Array.isArray(data)) {
                    data.push(value);
                }
            }
            else {
                cache.set(color, [value]);
            }
        }
        var preValue_1;
        cache.forEach(function (value, color) {
            var min = value[0];
            var max = value[value.length - 1];
            var range = [preValue_1 ? preValue_1 : min, max];
            preValue_1 = max;
            items.push({ color: color, value: range });
        });
    }
    else {
        items = legendItems.map(function (item) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, item), { value: [Math.ceil(item.value[0]), Math.ceil(item.value[1])] })); });
    }
    return items;
};
exports.getColorLegendItems = getColorLegendItems;
//# sourceMappingURL=helper.js.map